import { Component, isDevMode, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ProductsService } from 'src/app/services/products.service';
import { AuthService } from 'src/app/services/auth.service';
import { Permission } from 'src/app/constants/permission.constant';

@Component({
    selector: 'app-auto-suggestion',
    templateUrl: './auto-suggestion.component.html',
    styleUrls: ['./auto-suggestion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class AutoSuggestionComponent {
  suggestion = new FormControl('');
  suggestions: string[] = [];
  isShowing = false;
  readonly Permission = Permission;

  constructor(
    public _alert: MatSnackBar,
    private router: Router,
    private productService: ProductsService,
    public authService: AuthService,
  ) {}

  handleSuggestion(event: any) {
    if (event.key !== 'Enter') {
      return;
    }
    if (isDevMode()) {
      console.log('[DEV] [AutoSuggestionComponent] search submitted', event.target.value);
    }
    this.handleSearch(event.target.value);
  }
  search() {
    if (this.suggestion.value !== '') {
      this.handleSearch(this.suggestion.value || '');
    }
  }

  handleSearch(key: string) {
    const code = key.trim();

    this.suggestions = [];
    this.isShowing = !!code;
    if (!!code && code.toString().length >= 4) {
      this.isShowing = true;
      this.productService.setCodeSearch(code);
      this.router.navigateByUrl(`product-search/${code}`);
    } else {
      this._alert.open('Input at least 4 characters', 'close', {
        horizontalPosition: 'right',
        verticalPosition: 'top',
        duration: 3000,
        panelClass: ['error'],
      });
    }
  }
}
